import type { SessionCredentials } from '@filmsloth/shared';
import { brandedKey } from '../lib/brandedKey.js';

const KEY = brandedKey('credentials');

/** Credentials survive a reload so refreshing does not kick you out. */
export function loadCredentials(): SessionCredentials | null {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<SessionCredentials>;
    if (!parsed.code || !parsed.participantId || !parsed.token) return null;
    return parsed as SessionCredentials;
  } catch {
    return null;
  }
}

export function saveCredentials(credentials: SessionCredentials): void {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(credentials));
  } catch {
    // Private mode or a full quota: staying in memory is good enough.
  }
}

export function clearCredentials(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // Ignore — nothing depends on the removal succeeding.
  }
}
